import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {TextField} from "office-ui-fabric-react";
import React = require("react");
import {FileUtilities} from "../utilities/FileUtilities";

export interface NewFileNameTextFieldState extends ITeamsBaseComponentState {
    fileName: string;
    errorMessage: string;
}

export interface NewFileNameTextFieldProps {
    isDisabled: boolean;
    initialFileName: string;
    onErrorCheck: (isError: boolean) => void;
    onFileNameChange: (fileName: string) => void;
}

export class NewFileNameTextField extends TeamsBaseComponent<NewFileNameTextFieldProps, NewFileNameTextFieldState> {
    private extension: string;

    constructor(props: NewFileNameTextFieldProps) {
        super(props);

        this.extension = FileUtilities.getExtension(props.initialFileName);
        this.state = {
            theme: null,
            fileName: FileUtilities.removeExtension(props.initialFileName),
            errorMessage: "",
        };
    }

    public render() {
        return (
            <div>
                <TextField
                    required={true}
                    disabled={this.props.isDisabled}
                    label="File Name"
                    errorMessage={this.state.errorMessage}
                    multiline={false}
                    onChange={this.updateFileName}
                    autoComplete="off"
                    onBlur={this.validateFileName}
                    placeholder="Enter file title (without extension)"
                    validateOnFocusOut={true}
                    value={this.state.fileName}
                />
            </div>
        );
    }

    private updateFileName = (_event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, fileName: string) => {
        const trimmedFileName = fileName.trim();
        this.setState({fileName: fileName});
        this.props.onFileNameChange(trimmedFileName + this.extension);
    };

    private validateFileName = (_event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const errorMessage = this.getFileNameError(this.state.fileName);
        this.setState({errorMessage: errorMessage});
        this.props.onErrorCheck(errorMessage != "");
    };

    public getFileNameError = (fileName: string) => {
        if (!fileName || fileName.length == 0) {
            return "File requires a name.";
        } else {
            return "";
        }
    };
}
